import React, {useState} from 'react'
import SearchBar from './SearchBar'
import SearchProductDialog from './SearchProductDialog'
import {useDispatch} from 'react-redux'
import {
  setExistingItems,
  resetSearchState,
} from 'app/features/orders/redux/product/searchProductSlice'

interface Props {
  onAddProduct: (value: any) => void
  items: any[]
}

export const SearchProducts: React.FC<Props> = (props) => {
  const dispatch = useDispatch()
  const [searchText, setSearchText] = useState('')
  const [showDialog, setShowDialog] = useState(false)

  const handleSearch = (value: any) => {
    setSearchText(value)
    if (value.length) {
      setShowDialog(true)
      dispatch(setExistingItems(props.items))
    }
  }

  const handleClose = () => {
    setShowDialog(false)
    setSearchText('')
    dispatch(resetSearchState())
  }

  const handleAddProducts = (value: any) => {
    props.onAddProduct(value)
    handleClose()
  }

  return (
    <>
      <SearchBar onHandleSearch={handleSearch} searchText={searchText} />
      {showDialog && (
        <SearchProductDialog
          onClose={handleClose}
          searchedText={searchText}
          onAdd={handleAddProducts}
        />
      )}
    </>
  )
}

export default SearchProducts
